import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import calendarReducer from './slices/calendar';
import chatReducer from './slices/chat';
import kanbanReducer from './slices/kanban';
import mailReducer from './slices/mail';
import productReducer from './slices/product';
// features
import orderReducer from './features/order/orderSlice';
import orgUsersReducer from './features/orgUsers/orgUsersSlice';
import parentOrgReducer from './features/parentOrganization/parentOrgSlice';
import productsReducer from './features/product/productSlice';
import subOrgReducer from './features/subOrganization/subOrgSlice';
import invoiceReducer from './features/subOrganization/invoiceSlice';
import systemConfigReducer from './features/systemConfig/systemConfigSlice';
import adminUsersReducer from './features/admin/adminUsersSlice';
import actionLogReducer from './features/actionLog/actionLogSlice';

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  calendar: calendarReducer,
  chat: chatReducer,
  kanban: kanbanReducer,
  mail: mailReducer,
  product: productReducer,
  orders: orderReducer,
  orgUsers: orgUsersReducer,
  parentOrgs: parentOrgReducer,
  products: productsReducer,
  subOrgs: subOrgReducer,
  invoices: invoiceReducer,
  systemConfig: systemConfigReducer,
  adminUsers: adminUsersReducer,
  actionLogs: actionLogReducer,
});

export default rootReducer;